import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBTypography } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalexpert from './Modalexpert';
import Modalexpertbn from './Modalexpertbn';
import Commentbnlist from './Commentbnlist';
import Commentbnlistfromex from './Commentbnlistfromex';

//import Modalarticletyps from './Modalarticletypes';+
import { URL,api } from '../../api';
import Modaladdexpert from '../superadmin/Modaladdexpert';
import Modalarticleaddexpert from '../superadmin/Modalarticleaddexpert';
import Modalsentpassbn from '../adminfaculty/Modalsentpassbn';
import Modalsentpassforbn from '../adminfaculty/Modalsentpassforbn';
import Commentexlistforadmin from './Commentexlistforadmin';
import Modalsentpassforex from '../adminfaculty/Modalsentpassforex';
import Modaleditstatuspsf from '../superadmin/Modaleditstatuspsf';
import Commentexlistpsf from './Commentexlistpsf';
import Commentexlistpsfsentback from './Commentexlistpsfsentback';
import Modalexpercommentbacktbn2 from './Modalexpercommentbacktbn2';
import Swal from 'sweetalert2'
import Modalsetrob from './Modalsetrob';
import Modalreportcomment from './Modalreportcomment';
import Modalsetrobpresent from './Modalsetrobpresent';







var Latex = require('react-latex');





export default class expertexpresent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            articleex:[],
            extertype:'',
            expert_id:'',
            url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
           //  url:'https://git.kpru.ac.th/FrontEnd_Kprupsf/',
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.selectex = this.selectex.bind(this);
         this.dow = this.dow.bind(this);
         this.extertype = this.extertype.bind(this);
         this.printreport = this.printreport.bind(this);
         this.list = this.list.bind(this);
         
      }


    componentDidMount() {

      setTimeout(() => {
       // api.get('registercon/selectArticleforexpertbn/'+localStorage.getItem('iduser') )
       api.get('registercon/SelectArticleforexpsfpresent')
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('iduser')})
           }) 
       }, 0);

       
      }

          list() {

      setTimeout(() => {
       // api.get('registercon/selectArticleforexpertbn/'+localStorage.getItem('iduser') )
       api.get('registercon/SelectArticleforexpsfpresent')
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('iduser')})
           }) 
       }, 0);

       
      }


       printreport = (index,id_articlepsf,nameuser,typelevel) => evt => {
         console.log(evt.target.checked)
         console.log(index)
         console.log(id_articlepsf)
         console.log(nameuser)
         console.log(typelevel)

         Swal.fire({
           title: "ยืนยันการพิมพ์รายงาน",
           text: "หากพิมพ์รายงานแล้ว กรรมการจะไม่สามารถแก้ไขข้อมูลได้",
           icon: "warning",
           showCancelButton: true,
           confirmButtonColor: "#3085d6",
           cancelButtonColor: "#d33",
           confirmButtonText: "ยืนยัน",
           cancelButtonText: 'ยกเลิก'
         }).then((result) => {
                                                                                       
         
          if (result.isConfirmed) {  

                          
                               const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                               datafrm.append("id_articlepsf", id_articlepsf);
                               datafrm.append("id_emp", index);
                             
                               
                           api.post("registercon/updatecheckprint",datafrm,{
                             headers: {
                                 'content-type': 'multipart/form-data'
                             }
                            })
                         
                            .then(res => {
                            
                                if (res.data = '200') {
                                 
                                        window.open(
                                          "https://e-student.kpru.ac.th/approve/psfpdf/TCPDF-main/printpdfto.php?id_emp="+index+
                                            "&id_articlepsf=" +
                                            id_articlepsf +
                                            "&nameuser=" +
                                            nameuser +
                                            "&typelevel=" +
                                            typelevel 
                                          
                                        );
                                       
                                }else{
                                      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                                }
                           })
                        



            }else{
             // this.setState({ loadding: false })
             // this.toggle();
            }
          })

       }



      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectArticleforexpertbnandadmin/'+localStorage.getItem('presentype_id') )
          .then(res => {
        //    console.log(res);
          //  this.setState({ bankname: res.data, loading: false })
            this.setState({ article: res.data})
            this.setState({ expert_id: localStorage.getItem('iduser')})
          }) 
      }, 0);
      
      }



      selectex() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertatbn.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 

         }, 0);



      }

      extertype() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertattype.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res.data[0].expert_type);
           //  this.setState({ bankname: res.data, loading: false })
        //     this.setState({ extertype: res.data[0].expert_type})
           }) 

         }, 0);



      }

      

      dow(){
       
           
          if (localStorage.getItem('expert_id') !== null) {

              if (this.state.extertype === '1') {
                 window.open(
                    'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') ,
                    '_blank' // <- This is what makes it open in a new window.
                  );
              }else{
                window.open(
                  'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite2.php?expert_id='+localStorage.getItem('expert_id') ,
                  '_blank' // <- This is what makes it open in a new window.
                );

              }

           // window.location.href = 'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') 
           

        } else {
        }
      }



    render() {
      console.log(this.state.expert_id)
        return (
            <MDBContainer fluid>
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (เจ้าหน้าที่)</p>
        


               {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความเข้าใหม่</h2>
                </MDBAlert> */}
                <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="ผลงานรออนุมัติจากการประชุมรอบปัจจุบัน"
                                    subTitle="ผลงานรออนุมัติจากการประชุมรอบปัจจุบัน "
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                </MDBAlert>    

           
                <h3>
               
            </h3>

                <MDBTable bordered responsive striped>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th >ชื่อเรื่อง</th>
                        <th >ผู้ส่ง</th>
                        <th >วันที่ส่ง</th>
                        <th >ผลการประเมิน</th>
                        <th >การปรับแก้ไขหลังกรรมการตรวจ</th>
                        <th >จัดการรอบประกอบการประชุม</th>
                        
                        {/* <th>ประเภท</th>
                        <th>สถานะ</th> */}
                        {/* <th>จัดการผู้ทรงคุณวุฒิ </th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                     <tr>

                            <td>{index+1}</td>
                            <td><span className="font-weight-bold">ผลงาน :</span>  <span className="teal-text font-weight-bold">  ผลงาน KPRU PSF</span> 
                            
                          
                            {/* <Modalarticleaddexpert id_send={article.id_send} name_article={article.name_article}  expert_id={localStorage.getItem('iduser')} bn_comment={article.bn_comment}	 /> */}
                            </td>
                             <td> <span className="teal-text font-weight-bold">{article.nameuser	}</span></td>
                             <td><span className="teal-text font-weight-bold">{article.dateadd	}
                              <br/>
                              {article.rob}
                              <Modalsetrob id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} list={this.list}/>
                              </span></td>
                             <td> <Commentexlistpsf id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} typelevel={article.typelevel}  />
                             {/* <MDBBtn color="primary" className="rounded-pill" onClick={this.printreport(article.id_emp,article.id_articlepsf,article.nameuser,article.typelevel)} size='sm' >พิมพ์รายงาน</MDBBtn> */}
                             <Modalreportcomment id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} nameuser={article.nameuser} typelevel={article.typelevel}  />
                             </td>
                             <td>
                              <Modalexpercommentbacktbn2 id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} nameuser={article.nameuser}  />
                               <Commentexlistpsfsentback id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} />
                               </td>
                              <td>
                                 {article.robpresent}
                                <Modalsetrobpresent id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} list={this.list} />
                                 </td>
                             

                             {/* <td> <Modaleditstatuspsf nameuser={article.nameuser} /> </td>
                           */}
                            
                         
                     </tr>
                    

                      )}
                    </MDBTableBody>
                    </MDBTable>

                 <hr/>

                {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความหลังผู้ทรงตรวจ</h2>
                </MDBAlert>
                <MDBTable bordered>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความสำหรับตรวจ</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articleex.map((articleex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articleex.send_name}</td>
                        <td>{articleex.major_precent}</td>
                        <td>
                           
                            <Commentbnlistfromex id_send={articleex.id_send} expert_id={this.state.expert_id}  />
                             </td>
                         <td>
                             
                             </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
